import React, { useEffect, useRef, useState } from "react";

import { Tooltip as ReactTooltip } from "react-tooltip";
import india_map from "../../assets/home/india_map.svg";
import Mappoints from "../../assets/Impact/Mappoints.png";
import axios from "axios";

type MapDetails = {
  digit: string;
  description: string;
};

type MapPoints = {
  stateName: string;
  buddhaFellows: number;
  jobsCreated: number;
  familyImpacted: number;
};
const Mapping = () => {
  const [activetooltip, setactivetooltip] = useState(null);
  const [mapapidata, setmapapidata] = useState<MapDetails[]>();
  const [mapPoints, setMapDetails] = useState<MapPoints[] | null>(null);

  const handleTooltipClick = (id: any) => {
    setactivetooltip(id);
  };

  const fetchDetails = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_LOCAL_URL}/api/mapDetails/show`
      );

      const points = await axios.get(`${process.env.REACT_APP_LOCAL_URL}/api/map-points`);
      console.log(points);
      if (response.status === 200) {
        setMapDetails(points.data.message);
        console.log(mapPoints);
      }

      if (response.status !== 200) {
      } else {
        // console.log(response.data.data);
        setmapapidata(response.data.data);
      }
    } catch (error: any) {
      // console.log("Some Error Occur" , error.message);
    }
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  return (
    <>
      <section className="bg-[#FFFBEF]">
        <div className="w-container-xl blade-top-padding-lg blade-bottom-padding-lg">
          <h1 className="text-[#07393C] font-lato-bold border-b border-[#84848480] py-3 lg:py-0">
            Mapping the collective impact{" "}
            <span className="text-[#3AB54B]">by our Buddha Fellows</span>
          </h1>

          <div className="flex lg:flex-row flex-col gap-4 lg:gap-40 blade-top-padding-sm blade-bottom-padding-sm">
            <div className="w-full lg:w-[50%]">
              <h4 className="font-lato-regular text-black/80 ">
                True potential, when nurtured, creates lasting impact. At the
                Buddha Institute, our Development Entrepreneurs are driving
                India’s grassroots to empowerment at scale through their
                diverse, innovative enterprises.
              </h4>
            </div>

            <div className="w-full  lg:w-[50%]">
              <h4 className="font-lato-regular text-black/80 ">
                Rooted in compassion, they see rural India and its citizens as
                the “centers for value addition”. By generating stable
                employment opportunities and livelihoods right at ground zero,
                these Development Entrepreneurs are enabling dignified living
                while reducing rural migration across India.
              </h4>
            </div>
          </div>

          <div>
            <div className="flex lg:flex-row flex-col justify-between ">
              <div className="border-l  lg:block hidden border-[#84848480] blade-top-margin-sm">
                {mapapidata?.map((elem, index) => {
                  return (
                    <React.Fragment key={index}>
                      <div className="px-5">
                        <h2 className="font-lato-bold  text-[#8DC63F]">
                          {elem.digit}
                        </h2>
                        <h3 className="font-lato-bold  text-[#22574D]">
                          {elem.description}
                        </h3>
                      </div>
                      <span className="block last:hidden h-[1px] w-[5rem] bg-[#84848480] my-3"></span>
                    </React.Fragment>
                  );
                })}
              </div>
              <div className="lg:hidden blade-top-margin-sm border-l border-[#84848480]">
                <div className="grid  lg:gap-5 lg:grid-cols-4 sm:grid-cols-3 grid-cols-2 ">
                  {mapapidata?.map((elem, index) => {
                    const isFullWidthItem =
                      elem.digit === "INR 20,000" || elem.digit === "4270 mt";
                    return (
                      <div
                        key={index}
                        className={`border-b border-[#84848480]  p-4    ${
                          isFullWidthItem ? "col-span-2 sm:col-span-1" : ""
                        }  ${
                          index === 0 || index === 4
                            ? " sm:border-r-0 border-r border-[#84848480] "
                            : ""
                        }
                          ${index === 6 ? " border-b-0 " : ""}
                      `}
                      >
                        <h1 className="text-[#8DC63F] font-lato-bold text-nowrap sm:text-wrap">
                          {elem.digit}
                        </h1>
                        <h4 className="text-[#22574D] font-lato-bold">
                          {elem.description}
                        </h4>
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className=" xl:w-[70%]  blade-top-padding-lg lg:pt-0">
                <div className=" xl:ms-[25%] relative">
                  <img src={india_map} className="w-full h-full lg:p-9 " />

                  <div
                    className={`absolute  w-[3%] h-[3%]  2xl:w-[3%] 2xl:h-[3%] left-[37%] top-[20%]   lg:left-[39%] lg:top-[23%] rounded-full ${
                      activetooltip == "tool1" ? " z-50 " : " z-10"
                    }`}
                    onMouseEnter={() => handleTooltipClick("tool1")}
                  >
                    <img
                      src={Mappoints}
                      className=" w-full  h-full "
                      id="tool1"
                    />
                    <ReactTooltip
                      anchorId="tool1"
                      place="right"
                      className="font-lato-bold"
                      style={{
                        whiteSpace: "pre-line",
                        color: "black",
                        backgroundColor: "white",
                        // fontSize: "15px",
                      }}
                    >
                      {mapPoints && mapPoints[0] && (
                        <ul>
                          <li className="text-teal">
                            {mapPoints[0].stateName}
                          </li>
                          <li className="flex items-center">
                            <span className="inline-block w-2 h-2 mr-2 bg-black rounded-lg"></span>
                            {mapPoints[0].buddhaFellows} Buddha Fellows
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[0].jobsCreated} Jobs created
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[0].familyImpacted} Families impacted
                          </li>
                        </ul>
                      )}
                    </ReactTooltip>
                  </div>

                  <div
                    className={`absolute hover:[999] w-[3%] h-[3%]  2xl:w-[3%] 2xl:h-[3%] left-[28%] top-[25%]  lg:left-[30%] lg:top-[27%] rounded-full ${
                      activetooltip == "tool2" ? " z-50 " : " z-10"
                    }`}
                    onMouseEnter={() => handleTooltipClick("tool2")}
                  >
                    <img
                      src={Mappoints}
                      className=" w-full h-full "
                      id="tool2"
                    />
                    <ReactTooltip
                      anchorId="tool2"
                      place="right"
                      className=" font-lato-bold"
                      style={{
                        whiteSpace: "pre-line",
                        color: "black",
                        backgroundColor: "white",
                        fontSize: "14px",
                      }}
                    >
                      {mapPoints && mapPoints[1] && (
                        <ul>
                          <li className="text-teal">
                            {mapPoints[1].stateName}
                          </li>
                          <li className="flex items-center">
                            <span className="inline-block w-2 h-2 mr-2 bg-black rounded-lg"></span>
                            {mapPoints[1].buddhaFellows} Buddha Fellows
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[1].jobsCreated} Jobs created
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[1].familyImpacted} Families impacted
                          </li>
                        </ul>
                      )}
                    </ReactTooltip>
                  </div>

                  <div
                    className={`absolute  w-[3%] h-[3%]  2xl:w-[3%] 2xl:h-[3%]   left-[40%] top-[30%]  lg:left-[40%] lg:top-[32%] rounded-full ${
                      activetooltip == "tool3" ? " z-50 " : " z-10"
                    }`}
                    onMouseEnter={() => handleTooltipClick("tool3")}
                  >
                    <img
                      src={Mappoints}
                      className=" w-full h-full "
                      id="tool3"
                    />
                    <ReactTooltip
                      anchorId="tool3"
                      place="right"
                      className="font-lato-bold"
                      style={{
                        whiteSpace: "pre-line",
                        color: "black",
                        backgroundColor: "white",
                        fontSize: "15px",
                      }}
                    >
                      {mapPoints && mapPoints[2] && (
                        <ul>
                          <li className="text-teal">
                            {mapPoints[2].stateName}
                          </li>
                          <li className="flex items-center">
                            <span className="inline-block w-2 h-2 mr-2 bg-black rounded-lg"></span>
                            {mapPoints[2].buddhaFellows} Buddha Fellows
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[2].jobsCreated} Jobs created
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[2].familyImpacted} Families impacted
                          </li>
                        </ul>
                      )}
                    </ReactTooltip>
                  </div>

                  <div
                    className={`absolute  w-[3%] h-[3%]  2xl:w-[3%] 2xl:h-[3%]   left-[58%] top-[36%]  lg:left-[57%] lg:top-[37%] rounded-full ${
                      activetooltip == "tool4" ? " z-50 " : " z-10"
                    }`}
                    onMouseEnter={() => handleTooltipClick("tool4")}
                  >
                    <img
                      src={Mappoints}
                      className=" w-full h-full "
                      id="tool4"
                    />
                    <ReactTooltip
                      anchorId="tool4"
                      place="right"
                      className="font-lato-bold"
                      style={{
                        whiteSpace: "pre-line",
                        color: "black",
                        backgroundColor: "white",
                        fontSize: "15px",
                      }}
                    >
                      {mapPoints && mapPoints[3] && (
                        <ul>
                          <li className="text-teal">
                            {mapPoints[3].stateName}
                          </li>
                          <li className="flex items-center">
                            <span className="inline-block w-2 h-2 mr-2 bg-black rounded-lg"></span>
                            {mapPoints[3].buddhaFellows} Buddha Fellows
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[3].jobsCreated} Jobs created
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[3].familyImpacted} Families impacted
                          </li>
                        </ul>
                      )}
                    </ReactTooltip>
                  </div>

                  <div
                    className={`absolute  w-[3%] h-[3%]  2xl:w-[3%] 2xl:h-[3%]   left-[47%] top-[51%] lg:left-[49%] lg:top-[50%] rounded-full ${
                      activetooltip == "tool87" ? " z-50 " : " z-10"
                    }`}
                    onMouseEnter={() => handleTooltipClick("tool87")}
                  >
                    <img
                      src={Mappoints}
                      className=" w-full h-full "
                      id="tool87"
                    />
                    <ReactTooltip
                      anchorId="tool87"
                      place="right"
                      className="font-lato-bold"
                      style={{
                        whiteSpace: "pre-line",
                        color: "black",
                        backgroundColor: "white",
                        fontSize: "15px",
                      }}
                    >
                      {mapPoints && mapPoints[4] && (
                        <ul>
                          <li className="text-teal">
                            {mapPoints[4].stateName}
                          </li>
                          <li className="flex items-center">
                            <span className="inline-block w-2 h-2 mr-2 bg-black rounded-lg"></span>
                            {mapPoints[4].buddhaFellows} Buddha Fellows
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[4].jobsCreated} Jobs created
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[4].familyImpacted} Families impacted
                          </li>
                        </ul>
                      )}
                    </ReactTooltip>
                  </div>

                  <div
                    className={`absolute   w-[3%] h-[3%]  2xl:w-[3%] 2xl:h-[3%]   left-[56%] top-[42%]  lg:left-[58%] lg:top-[45%] rounded-full ${
                      activetooltip == "tool6" ? " z-50 " : " z-10"
                    }`}
                    onMouseEnter={() => handleTooltipClick("tool6")}
                  >
                    <img
                      src={Mappoints}
                      className=" w-full h-full "
                      id="tool6"
                    />
                    <ReactTooltip
                      anchorId="tool6"
                      place="right"
                      className="font-lato-bold"
                      style={{
                        whiteSpace: "pre-line",
                        color: "black",
                        backgroundColor: "white",
                        fontSize: "15px",
                      }}
                    >
                      {mapPoints && mapPoints[5] && (
                        <ul>
                          <li className="text-teal">
                            {mapPoints[5].stateName}
                          </li>
                          <li className="flex items-center">
                            <span className="inline-block w-2 h-2 mr-2 bg-black rounded-lg"></span>
                            {mapPoints[5].buddhaFellows} Buddha Fellows
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[5].jobsCreated} Jobs created
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[5].familyImpacted} Families impacted
                          </li>
                        </ul>
                      )}
                    </ReactTooltip>
                  </div>

                  <div
                    className={`absolute   w-[3%] h-[3%]  2xl:w-[3%] 2xl:h-[3%]   left-[65%] top-[45%]  lg:left-[65%] lg:top-[45%] rounded-full ${
                      activetooltip == "tool7" ? " z-50 " : " z-10"
                    }`}
                    onMouseEnter={() => handleTooltipClick("tool7")}
                  >
                    <img
                      src={Mappoints}
                      className=" w-full h-full "
                      id="tool7"
                    />
                    <ReactTooltip
                      anchorId="tool7"
                      place="right"
                      className="font-lato-bold"
                      style={{
                        whiteSpace: "pre-line",
                        color: "black",
                        backgroundColor: "white",
                        fontSize: "15px",
                      }}
                    >
                      {mapPoints && mapPoints[6] && (
                        <ul>
                          <li className="text-teal">
                            {mapPoints[6].stateName}
                          </li>
                          <li className="flex items-center">
                            <span className="inline-block w-2 h-2 mr-2 bg-black rounded-lg"></span>
                            {mapPoints[6].buddhaFellows} Buddha Fellows
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[6].jobsCreated} Jobs created
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[6].familyImpacted} Families impacted
                          </li>
                        </ul>
                      )}
                    </ReactTooltip>
                  </div>

                  <div
                    className={`absolute   w-[3%] h-[3%]  2xl:w-[3%] 2xl:h-[3%]   left-[80%] top-[32%]  lg:left-[78%] lg:top-[34%] rounded-full ${
                      activetooltip == "tool8" ? " z-50 " : " z-10"
                    }`}
                    onMouseEnter={() => handleTooltipClick("tool8")}
                  >
                    <img
                      src={Mappoints}
                      className=" w-full h-full "
                      id="tool8"
                    />
                    <ReactTooltip
                      anchorId="tool8"
                      place="right"
                      className="font-lato-bold"
                      style={{
                        whiteSpace: "pre-line",
                        color: "black",
                        backgroundColor: "white",
                        fontSize: "15px",
                      }}
                    >
                      {mapPoints && mapPoints[7] && (
                        <ul>
                          <li className="text-teal">
                            {mapPoints[7].stateName}
                          </li>
                          <li className="flex items-center">
                            <span className="inline-block w-2 h-2 mr-2 bg-black rounded-lg"></span>
                            {mapPoints[7].buddhaFellows} Buddha Fellows
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[7].jobsCreated} Jobs created
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[7].familyImpacted} Families impacted
                          </li>
                        </ul>
                      )}
                    </ReactTooltip>
                  </div>

                  <div
                    className={`absolute   w-[3%] h-[3%]  2xl:w-[3%] 2xl:h-[3%]   left-[36%] top-[63%]  lg:left-[37%] lg:top-[62%] rounded-full ${
                      activetooltip == "tool10" ? " z-50 " : " z-10"
                    }`}
                    onMouseEnter={() => handleTooltipClick("tool10")}
                  >
                    <img
                      src={Mappoints}
                      className=" w-full h-full "
                      id="tool10"
                    />
                    <ReactTooltip
                      anchorId="tool10"
                      place="right"
                      className="font-lato-bold"
                      style={{
                        whiteSpace: "pre-line",
                        color: "black",
                        backgroundColor: "white",
                        fontSize: "15px",
                      }}
                    >
                      {mapPoints && mapPoints[8] && (
                        <ul>
                          <li className="text-teal">
                            {mapPoints[8].stateName}
                          </li>
                          <li className="flex items-center">
                            <span className="inline-block w-2 h-2 mr-2 bg-black rounded-lg"></span>
                            {mapPoints[8].buddhaFellows} Buddha Fellows
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[8].jobsCreated} Jobs created
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[8].familyImpacted} Families impacted
                          </li>
                        </ul>
                      )}
                    </ReactTooltip>
                  </div>

                  <div
                    className={`absolute   w-[3%] h-[3%]  2xl:w-[3%] 2xl:h-[3%]   left-[37%] top-[72%]  lg:left-[38%] lg:top-[70%] rounded-full ${
                      activetooltip == "tool11" ? " z-50 " : " z-10"
                    }`}
                    onMouseEnter={() => handleTooltipClick("tool11")}
                  >
                    <img
                      src={Mappoints}
                      className=" w-full h-full "
                      id="tool11"
                    />
                    <ReactTooltip
                      anchorId="tool11"
                      place="right"
                      className="font-lato-bold"
                      style={{
                        whiteSpace: "pre-line",
                        color: "black",
                        backgroundColor: "white",
                        fontSize: "15px",
                      }}
                    >
                      {mapPoints && mapPoints[9] && (
                        <ul>
                          <li className="text-teal">
                            {mapPoints[9].stateName}
                          </li>
                          <li className="flex items-center">
                            <span className="inline-block w-2 h-2 mr-2 bg-black rounded-lg"></span>
                            {mapPoints[9].buddhaFellows} Buddha Fellows
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[9].jobsCreated} Jobs created
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[9].familyImpacted} Families impacted
                          </li>
                        </ul>
                      )}
                    </ReactTooltip>
                  </div>

                  <div
                    className={`absolute   w-[3%] h-[3%]  2xl:w-[3%] 2xl:h-[3%]    left-[28%] top-[90%]   lg:left-[30%] lg:top-[88%] rounded-full ${
                      activetooltip == "tool12" ? " z-50 " : " z-10"
                    }`}
                    onMouseEnter={() => handleTooltipClick("tool12")}
                  >
                    <img
                      src={Mappoints}
                      className="w-full h-full "
                      id="tool12"
                    />
                    <ReactTooltip
                      anchorId="tool12"
                      place="right"
                      className="font-lato-bold"
                      style={{
                        whiteSpace: "pre-line",
                        color: "black",
                        backgroundColor: "white",
                        fontSize: "15px",
                      }}
                    >
                      {mapPoints && mapPoints[10] && (
                        <ul>
                          <li className="text-teal">
                            {mapPoints[10].stateName}
                          </li>
                          <li className="flex items-center">
                            <span className="inline-block w-2 h-2 mr-2 bg-black rounded-lg"></span>
                            {mapPoints[10].buddhaFellows} Buddha Fellows
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[10].jobsCreated} Jobs created
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[10].familyImpacted} Families impacted
                          </li>
                        </ul>
                      )}
                    </ReactTooltip>
                  </div>

                  <div
                    className={`absolute   w-[3%] h-[3%]  2xl:w-[3%] 2xl:h-[3%]   left-[23%] top-[75%]  lg:left-[26%] lg:top-[72%] rounded-full ${
                      activetooltip == "tool13" ? " z-50 " : " z-10"
                    }`}
                    onMouseEnter={() => handleTooltipClick("tool13")}
                  >
                    <img
                      src={Mappoints}
                      className=" w-full h-full "
                      id="tool13"
                    />
                    <ReactTooltip
                      anchorId="tool13"
                      place="right"
                      className="font-lato-bold"
                      style={{
                        whiteSpace: "pre-line",
                        color: "black",
                        backgroundColor: "white",
                        fontSize: "15px",
                      }}
                    >
                      {mapPoints && mapPoints[11] && (
                        <ul>
                          <li className="text-teal">
                            {mapPoints[11].stateName}
                          </li>
                          <li className="flex items-center">
                            <span className="inline-block w-2 h-2 mr-2 bg-black rounded-lg"></span>
                            {mapPoints[11].buddhaFellows} Buddha Fellows
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[11].jobsCreated} Jobs created
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[11].familyImpacted} Families impacted
                          </li>
                        </ul>
                      )}
                    </ReactTooltip>
                  </div>

                  <div
                    className={`absolute   w-[3%] h-[3%]  2xl:w-[3%] 2xl:h-[3%]   left-[19%] top-[58%]  lg:left-[25%] lg:top-[58%] rounded-full ${
                      activetooltip == "tool14" ? " z-50 " : " z-10"
                    }`}
                    onMouseEnter={() => handleTooltipClick("tool14")}
                  >
                    <img
                      src={Mappoints}
                      className=" w-full h-full "
                      id="tool14"
                    />
                    <ReactTooltip
                      anchorId="tool14"
                      place="right"
                      className="font-lato-bold"
                      style={{
                        whiteSpace: "pre-line",
                        color: "black",
                        backgroundColor: "white",
                        fontSize: "15px",
                      }}
                    >
                      {mapPoints && mapPoints[12] && (
                        <ul>
                          <li className="text-teal">
                            {mapPoints[12].stateName}
                          </li>
                          <li className="flex items-center">
                            <span className="inline-block w-2 h-2 mr-2 bg-black rounded-lg"></span>
                            {mapPoints[12].buddhaFellows} Buddha Fellows
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[12].jobsCreated} Jobs created
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[12].familyImpacted} Families impacted
                          </li>
                        </ul>
                      )}
                    </ReactTooltip>
                  </div>

                  <div
                    className={`absolute   w-[3%] h-[3%]  2xl:w-[3%] 2xl:h-[3%]   left-[15%] top-[33%]  lg:left-[20%]  lg:top-[33%] rounded-full ${
                      activetooltip == "tool15" ? " z-50 " : " z-10"
                    }`}
                    onMouseEnter={() => handleTooltipClick("tool15")}
                  >
                    <img
                      src={Mappoints}
                      className="w-full h-full "
                      id="tool15"
                    />
                    <ReactTooltip
                      anchorId="tool15"
                      place="right"
                      className="font-lato-bold"
                      style={{
                        whiteSpace: "pre-line",
                        color: "black",
                        backgroundColor: "white",
                        fontSize: "15px",
                      }}
                    >
                      {mapPoints && mapPoints[13] && (
                        <ul>
                          <li className="text-teal">
                            {mapPoints[13].stateName}
                          </li>
                          <li className="flex items-center">
                            <span className="inline-block w-2 h-2 mr-2 bg-black rounded-lg"></span>
                            {mapPoints[13].buddhaFellows} Buddha Fellows
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[13].jobsCreated} Jobs created
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[13].familyImpacted} Families impacted
                          </li>
                        </ul>
                      )}
                    </ReactTooltip>
                  </div>

                  <div
                    className={`absolute   w-[3%] h-[3%]  2xl:w-[3%] 2xl:h-[3%] left-[11%]  top-[45%]   lg:left-[14%] lg:top-[47%] rounded-full ${
                      activetooltip == "tool16" ? " z-50 " : " z-10"
                    }`}
                    onMouseEnter={() => handleTooltipClick("tool16")}
                  >
                    <img
                      src={Mappoints}
                      className=" w-full h-full "
                      id="tool16"
                    />
                    <ReactTooltip
                      anchorId="tool16"
                      place="right"
                      className="font-lato-bold"
                      style={{
                        whiteSpace: "pre-line",
                        color: "black",
                        backgroundColor: "white",
                        fontSize: "15px",
                      }}
                    >
                      {mapPoints && mapPoints[14] && (
                        <ul>
                          <li className="text-teal">
                            {mapPoints[14].stateName}
                          </li>
                          <li className="flex items-center">
                            <span className="inline-block w-2 h-2 mr-2 bg-black rounded-lg"></span>
                            {mapPoints[14].buddhaFellows} Buddha Fellows
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[14].jobsCreated} Jobs created
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[14].familyImpacted} Families impacted
                          </li>
                        </ul>
                      )}
                    </ReactTooltip>
                  </div>

                  <div
                    className={`absolute  w-[3%] h-[3%]  2xl:w-[3%] 2xl:h-[3%]   left-[29%] top-[45%]  lg:left-[31%] lg:top-[45%] rounded-full ${
                      activetooltip == "tool287" ? " z-50 " : " z-10"
                    }`}
                    onMouseEnter={() => handleTooltipClick("tool287")}
                  >
                    <img
                      src={Mappoints}
                      className=" w-full h-full "
                      id="tool287"
                    />
                    <ReactTooltip
                      anchorId="tool287"
                      place="right"
                      className="font-lato-bold"
                      style={{
                        whiteSpace: "pre-line",
                        color: "black",
                        backgroundColor: "white",
                        fontSize: "15px",
                      }}
                    >
                      {mapPoints && mapPoints[15] && (
                        <ul>
                          <li className="text-teal">
                            {mapPoints[15].stateName}
                          </li>
                          <li className="flex items-center">
                            <span className="inline-block w-2 h-2 mr-2 bg-black rounded-lg"></span>
                            {mapPoints[15].buddhaFellows} Buddha Fellows
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[15].jobsCreated} Jobs created
                          </li>
                          <li className="flex items-center mt-1">
                            <span className="inline-block w-2 h-2 bg-black mr-2 rounded-lg"></span>
                            {mapPoints[15].familyImpacted} Families impacted
                          </li>
                        </ul>
                      )}
                    </ReactTooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Mapping;
